"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getImageIdFromManifest = exports.getManifestLayers = exports.extractArchive = void 0;
const generic_archive_extractor_1 = require("../generic-archive-extractor");
Object.defineProperty(exports, "getManifestLayers", { enumerable: true, get: function () { return generic_archive_extractor_1.getManifestLayers; } });
var layer_1 = require("./layer");
Object.defineProperty(exports, "extractArchive", { enumerable: true, get: function () { return layer_1.extractArchive; } });
exports.getImageIdFromManifest = (0, generic_archive_extractor_1.createGetImageIdFromManifest)(generic_archive_extractor_1.kanikoArchiveConfig);
//# sourceMappingURL=index.js.map